import {awsFetchRest} from 'utils/asyncUtils'
import config from 'config'

class AccountPreferencesService {
  static saveAccountPreferences = (token, {sub, name, value}) =>
    awsFetchRest(
      `${config.identityServiceUrl}/accounts/${encodeURIComponent(sub)}/preferences`,
      'POST',
      {name, value},
      {Authorization: `Bearer ${token}`}
    )
}

export default AccountPreferencesService
